import React from 'react';
import ReactECharts from 'echarts-for-react';
import { motion } from 'framer-motion';

const ReportingAnalytics = () => {
  // Dummy data for visualization
  const engagementData = {
    tooltip: { trigger: 'axis' },
    legend: { data: ['Instagram', 'TikTok', 'X', 'Facebook'] },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: ['W1', 'W2', 'W3', 'W4'] },
    yAxis: { type: 'value' },
    series: [
      { name: 'Instagram', type: 'line', smooth: true, data: [120, 132, 101, 134], itemStyle: { color: '#6A4F3A' } }, // Brown
      { name: 'TikTok', type: 'line', smooth: true, data: [220, 182, 191, 234], itemStyle: { color: '#D5B26B' } }, // Gold
      { name: 'X', type: 'line', smooth: true, data: [150, 232, 201, 154], itemStyle: { color: '#4E7C59' } }, // Apache
      { name: 'Facebook', type: 'line', smooth: true, data: [320, 332, 301, 334], itemStyle: { color: '#A68A64' } } // Lighter Brown
    ]
  };

  const platformMix = {
    tooltip: { trigger: 'item' },
    legend: { top: '5%', left: 'center' },
    series: [
      {
        name: 'Follower Growth',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
        label: { show: false, position: 'center' },
        emphasis: { label: { show: true, fontSize: 20, fontWeight: 'bold' } },
        data: [
          { value: 1048, name: 'Instagram', itemStyle: { color: '#6A4F3A' } },
          { value: 735, name: 'TikTok', itemStyle: { color: '#D5B26B' } },
          { value: 580, name: 'Facebook', itemStyle: { color: '#4E7C59' } },
          { value: 484, name: 'X', itemStyle: { color: '#A68A64' } }
        ]
      }
    ]
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }}
      className="max-w-7xl mx-auto"
    >
      <h1 className="section-title">Reporting & Analytics</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        {/* Highlights */}
        <div className="bg-gradient-to-br from-apache to-[#3D6346] rounded-xl p-6 text-white shadow-lg border border-apache/20">
          <h3 className="text-beige/80 text-sm font-bold uppercase mb-1">Total Reach</h3>
          <div className="text-4xl font-bold">1.2M</div>
          <div className="text-beige/80 text-sm mt-2 flex items-center">
            <span className="bg-white/20 px-2 py-0.5 rounded text-xs mr-2">+12%</span> vs last month
          </div>
        </div>
        <div className="bg-gradient-to-br from-brown to-[#5A4230] rounded-xl p-6 text-white shadow-lg border border-brown/20">
          <h3 className="text-beige/80 text-sm font-bold uppercase mb-1">Avg. Engagement</h3>
          <div className="text-4xl font-bold">4.8%</div>
          <div className="text-beige/80 text-sm mt-2 flex items-center">
            <span className="bg-white/20 px-2 py-0.5 rounded text-xs mr-2">+0.5%</span> vs last month
          </div>
        </div>
        <div className="bg-gradient-to-br from-gold to-[#C4A059] rounded-xl p-6 text-brown shadow-lg border border-gold/20">
          <h3 className="text-brown/70 text-sm font-bold uppercase mb-1">New Followers</h3>
          <div className="text-4xl font-bold">+2,450</div>
          <div className="text-brown/70 text-sm mt-2 flex items-center">
            <span className="bg-black/10 px-2 py-0.5 rounded text-xs mr-2">+8%</span> vs last month
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="section-card">
          <h2 className="subsection-title">Engagement Trend (Monthly)</h2>
          <ReactECharts option={engagementData} style={{ height: '300px' }} />
        </div>
        <div className="section-card">
          <h2 className="subsection-title">Audience Growth Mix</h2>
          <ReactECharts option={platformMix} style={{ height: '300px' }} />
        </div>
      </div>

      <div className="section-card">
        <h2 className="subsection-title">Monthly Report Structure (Wizard)</h2>
        <div className="flex flex-wrap gap-4">
          {['Executive Summary', 'Performance Highlights', 'Challenges', 'Platform Metrics', 'Key Insights', 'Strategy Next Month'].map((step, i) => (
            <div key={i} className="flex items-center bg-beige/50 px-4 py-3 rounded-lg border border-gold/20">
              <div className="w-6 h-6 bg-gold text-brown rounded-full flex items-center justify-center text-xs font-bold mr-3">
                {i + 1}
              </div>
              <span className="text-sm font-medium text-brown">{step}</span>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default ReportingAnalytics;